import React, { useState, useEffect } from "react";
import axios from "axios";
import { message, Select } from "antd";
import { InputItem, InputNumberItem, ModalItem, SelectItem } from "../../../../../Components/Items";

const { Option } = Select;

const valoresIniciales = { codigo: "", nombre: "", seccionAlmacenId: undefined, largo: 800 };

const ModalAgregarPasillo = ({ visible, onClose, empresaId, proyectoId, mapaAlmacenId, headersToken, secciones, onCreado }) => {
  const [valores, setValores] = useState(valoresIniciales);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (visible) setValores(valoresIniciales);
  }, [visible]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const crear = async () => {
    if (!valores.codigo) {
      message.warning("Captura un código para el pasillo");
      return;
    }
    setGuardando(true);
    try {
      const largo = Number(valores.largo || 800);
      const res = await axios.post(
        "pasillo/agregarPasillo",
        {
          empresaId,
          proyectoId,
          mapaAlmacenId,
          seccionAlmacenId: valores.seccionAlmacenId,
          codigo: valores.codigo,
          nombre: valores.nombre,
          xInicio: 40,
          yInicio: 40,
          xFin: 40 + largo,
          yFin: 40,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Pasillo creado correctamente");
        onCreado({
          nodos: [
            {
              _id: res.data.nodoInicioId,
              mapaAlmacenId,
              seccionAlmacenId: valores.seccionAlmacenId,
              codigo: `${valores.codigo}-INICIO`,
              tipo: "inicio_pasillo",
              x: 40,
              y: 40,
              activo: true,
            },
            {
              _id: res.data.nodoFinId,
              mapaAlmacenId,
              seccionAlmacenId: valores.seccionAlmacenId,
              codigo: `${valores.codigo}-FIN`,
              tipo: "fin_pasillo",
              x: 40 + largo,
              y: 40,
              activo: true,
            },
          ],
          conexion: {
            _id: res.data.conexionId,
            mapaAlmacenId,
            nodoOrigenId: res.data.nodoInicioId,
            nodoDestinoId: res.data.nodoFinId,
            tipoDireccion: "bidireccional",
            tipoRecorrido: "pasillo",
            distanciaMetros: res.data.distanciaMetros,
            distanciaManual: false,
            activa: true,
          },
        });
        onClose();
      } else {
        message.error(res.data.error || "No se pudo crear el pasillo");
      }
    } catch (error) {
      console.error("Error al crear el pasillo:", error);
      message.error("No se pudo crear el pasillo");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <ModalItem
      title="Agregar pasillo"
      visible={visible}
      onCancel={onClose}
      onOk={crear}
      width={520}
      footer
      spinning={guardando}
      confirmLoading={guardando}
    >
      <p style={{ color: "#8a93a6", fontSize: 12 }}>
        Se crean el nodo de inicio y el de fondo del pasillo, más la conexión entre ellos. Puedes arrastrarlos después para
        acomodarlos, y agregar racks colgados de nodos "acceso a ubicaciones" que coloques a lo largo del pasillo.
      </p>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Código</div>
        <InputItem value={valores.codigo} onChange={(e) => actualizar({ codigo: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre (opcional)</div>
        <InputItem value={valores.nombre} onChange={(e) => actualizar({ nombre: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Sección (opcional)</div>
        <SelectItem width="100%" allowClear value={valores.seccionAlmacenId} onChange={(value) => actualizar({ seccionAlmacenId: value })}>
          {secciones.map((valorSeccion) => (
            <Option key={valorSeccion._id} value={String(valorSeccion._id)}>
              {valorSeccion.nombre}
            </Option>
          ))}
        </SelectItem>
      </div>
      <div>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Largo inicial (px)</div>
        <InputNumberItem style={{ width: "100%" }} min={100} value={valores.largo} onChange={(v) => actualizar({ largo: v })} />
      </div>
    </ModalItem>
  );
};

export default ModalAgregarPasillo;
